var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pageData)?_c(_vm.pageData.type,_vm._b({tag:"component"},'component',_vm.customProps,false)):_vm._e(),_vm._v(" "),_c('Notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }